export function compareFirmwareVersions(
  versionA: string,
  versionB: string,
  isAscending: boolean
): number {

  const parseFirmwareVersion = (value: string): {
    major: number;
    minor: number;
    develop: number;
  } => {
    // Expected format: "882-1, 6.13.751"
    const firmwareVersionText = value.split(',')[1]?.trim() ?? '0.0.0';
    const [major, minor, develop] = firmwareVersionText.split('.').map(Number);

    return {
      major: major || 0,
      minor: minor || 0,
      develop: develop || 0
    };
  };

  const leftVersion = parseFirmwareVersion(versionA);
  const rightVersion = parseFirmwareVersion(versionB);

  if (leftVersion.major !== rightVersion.major)
    return isAscending ? leftVersion.major - rightVersion.major : rightVersion.major - leftVersion.major;

  if (leftVersion.minor !== rightVersion.minor)
    return isAscending ? leftVersion.minor - rightVersion.minor : rightVersion.minor - leftVersion.minor;

  if (leftVersion.develop !== rightVersion.develop)
    return isAscending ? leftVersion.develop - rightVersion.develop : rightVersion.develop - leftVersion.develop;

  return 0;
}